import React from 'react'
import Image from '../assets/about.png'


//scroll
import { Link } from 'react-scroll'

//icons
import { FaGithub, FaTwitter } from 'react-icons/fa'

//animation fro the cool text
import { TypeAnimation } from 'react-type-animation'

//Motion
import { motion } from 'framer-motion'

//varients
import { fadeIn } from '../variants'

const Banner = () => {
  return (
    <section
      id="home"
      className="min-h-[85vh] lg:min-h-[75vh] flex items-center"
    >
      <div className="container mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-center lg:gap-x-12">
          {/* text */}
          <div className="flex-1 text-center font-secondary lg:text-left ">
            <motion.h1
              // motion effect
              variants={fadeIn('up', 0.3)}
              initial="hidden"
              whileInView={'show'}
              viewport={{ once:false, amount: 0.7 }}
              className="text-[50px] lg:text-[65px] font-bold mb-2 leading-[0.8]"
            >
              Daniel <span>Agbeleshe</span>
            </motion.h1>
            <motion.div
              className="mb-6 text-[36px] lg:text-[60px] font-secondary font-semibold uppercase leading-[1]"
              // motion effect
              variants={fadeIn('up', 0.5)}
              initial="hidden"
              whileInView={'show'}
              viewport={{ once:false, amount: 0.7 }}
            >
              <span className="mr-4">I specialize in</span>
              <TypeAnimation
                sequence={[
                  'React.js',
                  5000,
                  'TailWind',
                  5000,
                  'Next.js',
                  5000,
                  'Bootstrap',
                  5000,
                  'typescript',
                  5000,
                ]}
                speed={50}
                className="text-accent"
                wrapper="span"
                repeat={Infinity}
              />
            </motion.div>
            <motion.p
              className=" mb-8 max-w-lg mx-auto lg:mx-0"
              // motion effect
              variants={fadeIn('up', 0.7)}
              initial="hidden"
              whileInView={'show'}
              viewport={{ once:false, amount: 0.7 }}
            >
              I am an experienced front-end developer with a strong
              understanding of web development technologies such as HTML, CSS,
              and JavaScript and various frameworks they use.
            </motion.p>

            <motion.div
              className="items-center max-w-max gap-x-6 mx-auto lg:mx-0 mb-12"
              // motion effect
              variants={fadeIn('up', 0.9)}
              initial="hidden"
              whileInView={'show'}
              viewport={{ once:false, amount: 0.7 }}
            >
              <Link smooth={true}  to="contact">
              <button className="btn btn-lg">Contact Me</button>
              </Link>
            </motion.div>

            {/* my socials */}
            <motion.div
              className="flex text-[20px] gap-x-6 mx-auto lg:mx-0 max-w-max mt-2"
              // motion effect
              variants={fadeIn('up', 1.1)}
              initial="hidden"
              whileInView={'show'}
              viewport={{ once:false, amount: 0.7 }}
            >
              <a href="https://github.com/Agbeleshe">
                <FaGithub />
              </a>
              <a href="https://twitter.com/@Bioba_Daniel">
                <FaTwitter />
              </a>
            </motion.div>
          </div>

          {/* image */}
          <motion.div
            className="hidden lg:flex"
            // motion effect
            variants={fadeIn('down', 0.5)}
            initial="hidden"
            whileInView={'show'}
            viewport={{ once:false, amount: 0.7 }}
          >
            <img src={Image} alt="Daniel image" className="rounded-full" />
          </motion.div>
        </div>
      </div>
    </section>
  )
}

export default Banner
